import { queryCardList, queryConventionalList, translateConventional, sseRequest } from "@/views/zhiji/js/services/service.js";

export default {
    state: {
        clusterCards: [],
        cardTotals: "",
        logDetailData: null,
        showClusterReceive: false,
        conventionalData: {
            tableData: [],
            totals: 0,
            queryConditions: {}
        },
        currentLang: "en" //默认为英文
    },
    mutations: {
        updateCardList(state, cardData) {
            state.cardTotals = cardData.totalCards;
            state.clusterCards.splice(0, state.clusterCards.length, ...cardData.cardsList);
            cardData.length > 0 ? "" : (state.showClusterReceive = true);
        },
        updateClusterCardsByTranslate(state, payload) {
            // 更新卡片翻译结果(cluster_keywords，question_list)
            // 1. 找到这张卡片 2. 用id去更新
            const { clusterId, translateData = [] } = payload;
            state.clusterCards.some(item => {
                if (item.clusterId == clusterId) {
                    // 更新关键字
                    item.clusterKeywords = item.clusterKeywords.map(KeywordItem => {
                        const translate = translateData.find(newData => newData.id == KeywordItem.id);
                        return {
                            ...KeywordItem,
                            translate: translate ? translate.output : ""
                        };
                    });
                    // 更新问题列表
                    item.questionList = item.questionList.map(questionItem => {
                        const translate = translateData.find(newData => newData.id == questionItem.questionId);
                        return {
                            ...questionItem,
                            translate: translate ? translate.output : ""
                        };
                    });
                }
            });
        },
        updateLogDetail(state, data) {
            state.logDetailData = data.logDetailData;
        },
        clearCardTotals(state) {
            state.cardTotals = "";
        },
        updateConventionalData(state, dataList) {
            state.conventionalData.tableData = dataList.tableData;
            state.conventionalData.totals = dataList.totals;
        },
        updateConventionalQuery(state, data) {
            state.conventionalData.queryConditions = Object.assign({}, state.conventionalData.queryConditions, data);
        },
        updateCurrentLang(state, data) {
            state.currentLang = data;
        },
        updateConventionTranslateData(state, data) {
            state.conventionalData.tableData.forEach(oldItem =>
                data.forEach(newItem => (newItem.id == oldItem.rowId  ? (oldItem.translate = newItem.output) : null))
            );
        }
    },
    actions: {
        queryCardList(context, param) {
            queryCardList(param)
                .then(function(cardData) {
                    context.commit("updateCardList", cardData);
                })
                .catch(err => {
                    context.dispatch("showModal", {
                        type: "MessageModal",
                        data: {
                            type: "tip",
                            message: err.message
                        }
                    });
                });
        },
        queryConventionalList(context, param) {
            param && context.commit("updateConventionalQuery", param);
            queryConventionalList(context.state.conventionalData.queryConditions).then(function(data) {
                context.commit("updateConventionalData", data);
            });
        },
        // 点击翻译常规闭环页面
        translateConventionPage(context, param) {
            // type为3时，为混元翻译
            if (param.type === "3") {
                return sseRequest({
                    apiPath: "/xiaoyue-operation/stream/batchTranslateByHunYuan",
                    target: param.to,
                    list: typeof param.list === "string" ? JSON.parse(param.list) : param.list,
                    onMessage: event => {
                        const data = JSON.parse(event.data);
                        if (data.is_end) {
                            context.dispatch("queryConventionalList");
                        }
                    }
                });
            } else {
                return translateConventional(param).then(data => {
                    context.dispatch("queryConventionalList");
                    return data;
                });
            }
        },
        // 点击翻译聚类管理卡片
        translateClusterCards(context, { param, clusterId }) {
            // type为3时，为混元翻译
            if (param.type === "3") {
                const collectedTranslateData = [];
                sseRequest({
                    apiPath: "/xiaoyue-operation/stream/batchTranslateByHunYuan",
                    target: param.to,
                    list: typeof param.list === "string" ? JSON.parse(param.list) : param.list,
                    onMessage: event => {
                        const data = JSON.parse(event.data);
                        if (!data.is_end) {
                            collectedTranslateData.push(data);
                        } else {                  
                            context.commit("updateClusterCardsByTranslate", {
                                clusterId,
                                translateData: collectedTranslateData
                            });
                        }
                    }
                });
            } else {
                translateConventional(param).then(data => {       
                    context.commit("updateClusterCardsByTranslate", { clusterId, translateData: data })
                })
            }
        }
    }
};
